export class AppStateManager {
    constructor(appStateService) {
        this.appStateService = appStateService;
    }
    resetToSystemDefault() {
        this.appStateService.resetToSystemDefaultState();
    }
    deserialize(state) {
        return this.appStateService.deserialize(this.appStateService.serialize(state));
    }
}
